import React from 'react';
import screenAndStyle from '../_utils/screen-and-style';
import PostalCodeInput from '../_common/postal-code-input';
import classNames from 'classnames';
import { Popover, PopoverBody } from 'reactstrap';

export default function ZipcodePopover({
  onRef,
  popoverOpen,
  zipCodeValid,
  zipCode,
  handleZipCodeChange,
  handleZipCodeKeyUp,
  handleZipCodeUpdateClick,
  handleZipCodeCancelClick,
  shouldInputAutofocus,
}) {

  const setAutoFocus =
    typeof shouldInputAutofocus === 'undefined' ? true : shouldInputAutofocus;
  return (
    <Popover
      id="zip-code-popover"
      placement={
        screenAndStyle.isBootstrapXS() || screenAndStyle.isBootstrapSM()
          ? 'top'
          : 'right'
      }
      target="popover-anchor"
      isOpen={popoverOpen}>
      <PopoverBody>
        <PostalCodeInput
          id='popover-update-postal-code'
          onInputRef={onRef}
          initialValue={zipCode}
          onChange={handleZipCodeChange}
          onKeyUp={handleZipCodeKeyUp}
          labelClassName='m-0 text-muted'
          wrapperClassName='form-group mb-2'
          required
          autoFocus={setAutoFocus}
          showPlaceholder
        />
        <button
          type="button"
          className={classNames('btn btn-primary')}
          disabled={!zipCodeValid}
          onClick={handleZipCodeUpdateClick}>
          Ok
        </button>
        <button
          type="button"
          className="btn btn-link"
          onClick={handleZipCodeCancelClick}>
          Cancel
        </button>
      </PopoverBody>
    </Popover>
  );
}
